<template>
  <button type="button" class="instButton instApplyButton" v-on:click="goTo">Подать заявку</button>
</template>

<script>
export default {
  name: "instApplyButton",
  methods: {
    goTo() {
      document.getElementById('formWrap').scrollIntoView({behavior: 'smooth'});
    }
  }
}
</script>

<style scoped>
.instApplyButton{margin-top: var(--font-size-30);}
</style>
